import { Component, OnInit, ViewChild } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { SchoolService } from "../../../shared/services/school.service";
import { AcademyService } from "../../Report/report-services/academy.service";
import { GradeLevelService } from "../../Report/report-services/grade-level.service";
import { GroupService } from "../../Report/report-services/group.service";
import { HomeroomService } from "../../Report/report-services/homeroom.service";
import { SchoolselectorComponent } from "../../schoolselector/schoolselector/schoolselector.component";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { SchoolAdminService } from "../services/schooladmin.service";
import { ZeroOutFMRequest } from "../services/ZeroOutFMRequest";
import { ZeroOutMeritRequest } from "../services/ZeroOutMeritRequest";
import { ZeroOutPBISRequest } from "../services/ZeroOutPBISRequest";
import { AccountSummaryReportComponent } from "./account-summary-report/account-summary-report.component";
import * as moment from "moment";

@Component({
	selector: "app-zero-out-accounts",
	templateUrl: "./zero-out-accounts.component.html",
	styleUrls: ["./zero-out-accounts.component.css"],
})
export class ZeroOutAccountsComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private userService: UserService,
		private schoolService: SchoolService,
		private confirmationService: ConfirmationService,
		private schoolAdminService: SchoolAdminService,
		private dialogService: DialogService,
		private homeroomService: HomeroomService,
		private academyService: AcademyService,
		private gradelevelService: GradeLevelService,
		private groupService: GroupService
	) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.loadPermissions();

		// this.loadSchoolist();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			this.onSchoolChange(school);
		});

		this.ActiveOption = this.lstActiveOption[0];
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	//////////////////////////////////////
	// Data
	//////////////////////////////////////

	@ViewChild(SchoolselectorComponent)
	schoolRef: SchoolselectorComponent;

	subscription: any;

	user: any;

	PermissionLoading: any = true;
	MeritAllowed: boolean = false;
	PBISAllowed: boolean = false;

	School: any;
	// lstSchool: any = [];

	ZeroFines: any = false;
	ZeroMeals: any = false;
	AdjustStudent: any = false;
	AdjustSchool: any = false;

	GradeLevelLoading: any = true;
	GradeLevel: any;
	lstGradeLevel: any = [];

	HomeroomLoading: any = true;
	Homeroom: any;
	lstHomeroom: any = [];

	AcademyLoading: any = true;
	Academy: any;
	lstAcademy: any = [];

	GroupLoading: any = true;
	Group: any;
	lstGroup: any = [];

	ActiveOption: any;

	FMStartDate: Date = new Date();
	FMEndDate: Date = new Date();

	lstActiveOption: any = [
		{
			ID: -1,
			Desc: "All",
		},
		{
			ID: 1,
			Desc: "Active",
		},
		{
			ID: 0,
			Desc: "Inactive",
		},
	];

	MeritStartDate: Date = new Date();
	MeritEndDate: Date = new Date();

	PBISStartDate: Date = new Date();
	PBISEndDate: Date = new Date();

	errorMessage: any = "";

	isProcessing: any = false;

	FMRangeOption: any = "All"; // All | Date
	MeritRangeOption: any = "All"; // All | Date
	PBISRangeOption: any = "All"; // All | Date

	//////////////////////////////////////

	//////////////////////////////////////
	// Load Data
	//////////////////////////////////////
	// loadSchoolist() {
	//   var result = this.schoolService.loadSchoolList("");
	//   result.subscribe(
	//     response => {
	//       this.lstSchool = response;
	//       // this.School = this.lstSchool[0];
	//     },
	//     error => {
	//     }
	//   )
	// }

	loadPermissions() {
		this.PermissionLoading = true;

		var result = this.schoolAdminService.ZeroPermissionSelect(this.user.userID);
		result.subscribe(
			(response) => {
				var Info: any = response;

				if (Info != undefined) {
					this.MeritAllowed = Info.MeritAllowed;
					this.PBISAllowed = Info.PBISAllowed;
				}

				this.PermissionLoading = false;
			},
			(error) => {
				this.PermissionLoading = false;
			}
		);
	}

	loadGradeLevel() {
		this.GradeLevelLoading = true;

		var result = this.gradelevelService.loadGradeLevelList("", this.School.SchoolID);
		result.subscribe(
			(response) => {
				this.lstGradeLevel = response;

				if (this.lstGradeLevel.length == 0) {
					this.lstGradeLevel.unshift({
						GradeLevelID: -1,
						GradeLevelDesc: "All",
					});
				}

				this.GradeLevel = this.lstGradeLevel[0];

				this.GradeLevelLoading = false;
			},
			(error) => {
				this.GradeLevelLoading = false;
			}
		);
	}

	loadHomeroom() {
		this.HomeroomLoading = true;

		var result = this.homeroomService.loadHomeroomList("", this.School.SchoolID);
		result.subscribe(
			(response) => {
				this.lstHomeroom = response;

				if (this.lstHomeroom.length == 0) {
					this.lstHomeroom.unshift({
						HomeroomId: -1,
						HomeRoom: "All",
					});
				}

				this.Homeroom = this.lstHomeroom[0];

				this.HomeroomLoading = false;
			},
			(error) => {
				this.HomeroomLoading = false;
			}
		);
	}

	loadAcademy() {
		this.AcademyLoading = true;

		var result = this.academyService.loadAcademyList("", this.School.SchoolID);
		result.subscribe(
			(response) => {
				this.lstAcademy = response;

				if (this.lstAcademy.length == 0) {
					this.lstAcademy.unshift({
						AcademyId: -1,
						AcademyDesc: "All",
					});
				}

				this.Academy = this.lstAcademy[0];

				this.AcademyLoading = false;
			},
			(error) => {
				this.AcademyLoading = false;
			}
		);
	}

	loadGroup() {
		this.GroupLoading = true;

		var result = this.groupService.loadGroupList("", this.School.SchoolID);
		result.subscribe(
			(response) => {
				this.lstGroup = response;

				if (this.lstGroup.length == 0) {
					this.lstGroup.unshift({
						GroupID: -1,
						GroupName: "All",
					});
				}

				this.Group = this.lstGroup[0];

				this.GroupLoading = false;
			},
			(error) => {
				this.GroupLoading = false;
			}
		);
	}

	//////////////////////////////////////

	//////////////////////////////////////
	// Buttons
	//////////////////////////////////////
	onProcessFinesMeals() {
		this.errorMessage = "";

		//Error handling
		if (this.ZeroFines == false && this.ZeroMeals == false) {
			this.errorMessage = "No account option selected. Please select Fines, Meals, or Both";
			return;
		} else if (this.AdjustStudent == false && this.AdjustSchool == false) {
			this.errorMessage = "No adjustment type selected. Please select adjust what the student owes, adjust what the school owes, or both.";
			return;
		} else if (this.FMRangeOption == "Date" && this.FMStartDate == undefined) {
			this.errorMessage = "Select start date";
			return;
		} else if (this.FMRangeOption == "Date" && this.FMEndDate == undefined) {
			this.errorMessage = "Select end date";
			return;
		} else {
			// var SelectedSchoolName: any = "";
			// for(var i = 0; i < this.lstSchool.length; i++){
			//   var next = this.lstSchool[i];

			//   if(next.SchoolID == this.SchoolID){
			//     SelectedSchoolName = "[" + next.SchoolNumber + "] - " + next.SchoolName;
			//     break;
			//   }
			// }

			var WarnMsg =
				"Zeroing out Fines/Meals Account balances is NOT REVERSIBLE, would you like to continue for school: " +
				"[" +
				this.School.SchoolNumber +
				"] - " +
				this.School.SchoolName +
				"?";

			this.confirmationService.confirm({
				key: "confirm",
				acceptLabel: "Yes",
				rejectVisible: true,
				rejectLabel: "No",
				message: WarnMsg,
				header: "Zero Account Process - Confirmation",
				icon: "fa",
				accept: () => {
					this.FinishProcessFinesMeals();
				},
				reject: () => {
					return;
				},
			});
		}
	}

	FinishProcessFinesMeals() {
		this.isProcessing = true;

		let parms: ZeroOutFMRequest = {
			ZeroOutFines: this.ZeroFines == true ? 1 : 0,
			ZeroOutMeals: this.ZeroMeals == true ? 1 : 0,
			ZeroCredit: this.AdjustSchool == true ? 1 : 0,
			ZeroDebit: this.AdjustStudent == true ? 1 : 0,
			SchoolID: this.School.SchoolID,
			GradeLevelID: this.GradeLevel.GradeLevelID,
			HomeroomID: this.Homeroom.HomeroomId,
			AcademyID: this.Academy.AcademyId,
			GroupID: this.Group.GroupID,
			Active: this.ActiveOption.ID,
			c_PersonID: this.user.personID,
			UseDateRange: this.FMRangeOption == "Date" ? 1 : 0,
			StartDate: moment(this.FMStartDate).format("MM/DD/YYYY"),
			EndDate: moment(this.FMEndDate).format("MM/DD/YYYY"),
		};

		var result = this.schoolAdminService.ZeroOutFinesMeals(parms);
		result.subscribe(
			(response) => {
				this.isProcessing = false;

				//
				// bool IsError { get; set; } = false;
				// string ErrorMessage { get; set; } = "";
				// int RowFine { get; set; } = 0;
				// int RowMeal { get; set; } = 0;
				//
				var RespInfo: any = response;

				var SuccessMsg = "";
				var FailMsg = "";

				if (this.ZeroFines == true && this.ZeroMeals == true) {
					SuccessMsg =
						"Fines and Meal accounts were zeroed out successfully. " +
						RespInfo.RowFine +
						" fine balances were reset and " +
						RespInfo.RowMeal +
						" meal balances were reset.";
					FailMsg = "Could not zero out Fine and Meal accounts: " + RespInfo.ErrorMessage;
				} else if (this.ZeroFines == true && this.ZeroMeals == false) {
					SuccessMsg = "Fines were zeroed out successfully. " + RespInfo.RowFine + " fine balances were reset.";
					FailMsg = "Could not zero out Fines: " + RespInfo.ErrorMessage;
				} else if (this.ZeroFines == false && this.ZeroMeals == true) {
					SuccessMsg = "Meal accounts were zeroed out successfully. " + RespInfo.RowMeal + " meal balances were reset.";
					FailMsg = "Could not zero out Meal Accounts: " + RespInfo.ErrorMessage;
				}

				if (RespInfo.IsError == false) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "result",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: SuccessMsg,
						header: "Success",
						icon: "fa",
						accept: () => {},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "result",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: FailMsg,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.isProcessing = false;
			}
		);
	}

	onPrintFinesMeals() {
		this.errorMessage = "";

		var ref = this.dialogService.open(AccountSummaryReportComponent, {
			header: "Account Summary Report",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				// lstSchool: this.lstSchool,
				user: this.user,
			},
		});
		ref.onClose.subscribe((response) => {
			//School Might have changed in the print window
			// this.School = response;
			this.schoolRef.onSchoolChange(response);
		});
	}

	onProcessMeritsDemerits() {
		this.errorMessage = "";

		if (this.MeritStartDate == undefined) {
			this.errorMessage = "Select start date";
			return;
		} else if (this.MeritEndDate == undefined) {
			this.errorMessage = "Select end date";
			return;
		} else if (this.School == undefined || this.School.SchoolID <= 0) {
			this.errorMessage = "Select a School";
			return;
		} else {
			// var SelectedSchoolName: any = "";
			// for(var i = 0; i < this.lstSchool.length; i++){
			//   var next = this.lstSchool[i];

			//   if(next.SchoolID == this.SchoolID){
			//     SelectedSchoolName = "[" + next.SchoolNumber + "] - " + next.SchoolName;
			//     break;
			//   }
			// }

			var WarnMsg =
				"Zeroing out Merits/Demerits is NOT REVERSIBLE, would you like to continue for school: " +
				"[" +
				this.School.SchoolNumber +
				"] - " +
				this.School.SchoolName +
				"?";

			this.confirmationService.confirm({
				key: "confirm",
				acceptLabel: "Yes",
				rejectVisible: true,
				rejectLabel: "No",
				message: WarnMsg,
				header: "Zero Merits/Demerits Process - Confirmation",
				icon: "fa",
				accept: () => {
					this.FinishZeroMerits();
				},
				reject: () => {
					return;
				},
			});
		}
	}

	FinishZeroMerits() {
		this.isProcessing = true;

		let parms: ZeroOutMeritRequest = {
			SchoolID: this.School.SchoolID,
			GradeLevelID: this.GradeLevel.GradeLevelID,
			HomeroomID: this.Homeroom.HomeroomId,
			AcademyID: this.Academy.AcademyId,
			GroupID: this.Group.GroupID,
			Active: this.ActiveOption.ID,
			UseDateRange: this.MeritRangeOption == "Date" ? 1 : 0,
			StartDate: moment(this.MeritStartDate).format("MM/DD/YYYY"),
			EndDate: moment(this.MeritEndDate).format("MM/DD/YYYY"),
		};

		var result = this.schoolAdminService.ZeroOutMerits(parms);
		result.subscribe(
			(response) => {
				this.isProcessing = false;

				var RespInfo: any = response;

				if (RespInfo.IsError == false) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "result",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Merits have been zeroed out successfully. " + RespInfo.RowCount + " merits/demerits were deleted.",
						header: "Success",
						icon: "fa",
						accept: () => {},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "result",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not zero out merits: " + RespInfo.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.isProcessing = false;
			}
		);
	}

	onProcessPBIS() {
		this.errorMessage = "";

		if (this.MeritStartDate == undefined) {
			this.errorMessage = "Select start date";
			return;
		} else if (this.MeritEndDate == undefined) {
			this.errorMessage = "Select end date";
			return;
		} else if (this.School == undefined || this.School.SchoolID <= 0) {
			this.errorMessage = "Select a School";
			return;
		} else {
			// var SelectedSchoolName: any = "";
			// for(var i = 0; i < this.lstSchool.length; i++){
			//   var next = this.lstSchool[i];

			//   if(next.SchoolID == this.SchoolID){
			//     SelectedSchoolName = "[" + next.SchoolNumber + "] - " + next.SchoolName;
			//     break;
			//   }
			// }

			var WarnMsg = "Would you like to void all points for school: " + "[" + this.School.SchoolNumber + "] - " + this.School.SchoolName + "?";

			this.confirmationService.confirm({
				key: "confirm",
				acceptLabel: "Yes",
				rejectVisible: true,
				rejectLabel: "No",
				message: WarnMsg,
				header: "Zero PBIS Process - Confirmation",
				icon: "fa",
				accept: () => {
					this.FinishZeroPBIS();
				},
				reject: () => {
					return;
				},
			});
		}
	}

	FinishZeroPBIS() {
		this.isProcessing = true;

		let parms: ZeroOutPBISRequest = {
			SchoolID: this.School.SchoolID,
			GradeLevelID: this.GradeLevel.GradeLevelID,
			HomeroomID: this.Homeroom.HomeroomId,
			AcademyID: this.Academy.AcademyId,
			GroupID: this.Group.GroupID,
			Active: this.ActiveOption.ID,
			UseDateRange: this.PBISRangeOption == "Date" ? 1 : 0,
			StartDate: moment(this.PBISStartDate).format("MM/DD/YYYY"),
			EndDate: moment(this.PBISEndDate).format("MM/DD/YYYY"),
		};

		var result = this.schoolAdminService.ZeroOutPBIS(parms);
		result.subscribe(
			(response) => {
				this.isProcessing = false;

				var RespInfo: any = response;

				if (RespInfo.IsError == false) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "result",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "PBIS Points have been zeroed out successfully. " + RespInfo.RowCount + " Points were voided.",
						header: "Success",
						icon: "fa",
						accept: () => {},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "result",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not zero out PBIS points: " + RespInfo.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.isProcessing = false;
			}
		);
	}

	//////////////////////////////////////

	//////////////////////////////////////
	// Events
	//////////////////////////////////////

	onSchoolChange(val) {
		this.School = val;

		this.loadGradeLevel();
		this.loadHomeroom();
		this.loadAcademy();
		this.loadGroup();
	}

	//////////////////////////////////////

	//////////////////////////////////////
	// Helpers
	//////////////////////////////////////

	IsLoading() {
		return (
			this.isProcessing == true ||
			this.PermissionLoading ||
			this.GradeLevelLoading == true ||
			this.HomeroomLoading == true ||
			this.AcademyLoading == true ||
			this.GroupLoading == true
		);
	}

	//////////////////////////////////////
}
